import React, { useState } from 'react';
import logo from '../assets/smalllogo.jpg';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-black/95 backdrop-blur-sm fixed top-0 left-0 right-0 z-50 border-b border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center min-h-24">
          {/* Logo sekcija */}
          <div className="flex items-center space-x-4">
            <img
              src={logo}
              alt="Eagle AI Logo"
              className="w-50 h-24 rounded-lg object-cover"
            />
          </div>

          {/* Desktop navigacija */}
          <nav className="hidden lg:flex space-x-8">
            <a href="#problem" className="text-gray-300 hover:text-white transition-colors">Problem</a>
            <a href="#ponuda" className="text-gray-300 hover:text-white transition-colors">Ponuda</a>
            <a href="#proces" className="text-gray-300 hover:text-white transition-colors">Proces</a>
            <a href="#cenovnik" className="text-gray-300 hover:text-white transition-colors">Cenovnik</a>
            <a href="#faq" className="text-gray-300 hover:text-white transition-colors">FAQ</a>
            <a href="#kontakt" className="text-gray-300 hover:text-white transition-colors">Kontakt</a>
          </nav>

          {/* CTA dugme */}
          <div className="hidden lg:block">
            <a
              href="https://www.instagram.com/eagleai_agents/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg transition-colors whitespace-nowrap"
            >
              DM "CHATBOT"
            </a>
          </div>

          <button
            className="lg:hidden text-white"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
              />
            </svg>
          </button>
        </div>

        {/* Mobilni meni */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-800">
            <div className="flex flex-col space-y-4">
              <a href="#problem" className="text-gray-300 hover:text-white">Problem</a>
              <a href="#ponuda" className="text-gray-300 hover:text-white">Ponuda</a>
              <a href="#proces" className="text-gray-300 hover:text-white">Proces</a>
              <a href="#cenovnik" className="text-gray-300 hover:text-white">Cenovnik</a>
              <a href="#faq" className="text-gray-300 hover:text-white">FAQ</a>
              <a href="#kontakt" className="text-gray-300 hover:text-white">Kontakt</a>
              <a
                href="https://www.instagram.com/eagleai_agents/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-blue-600 text-white px-4 py-2 rounded-lg text-center"
              >
                DM "CHATBOT"
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;